;(function () {
    const microModalSettings = {
        openClass: 'is-open',
        onShow: () => {
            document.body.classList.add('modal-open')
        },
        onClose: () => {
            document.body.classList.remove('modal-open')
        },
    }

    function modals() {
        MicroModal.init(microModalSettings)
    }

    /**
     *
     * Popups that show after x seconds when you first load the site
     *
     */
    // function entryPopup() {
    //     if (!show_entry_popup) {
    //         return
    //     }

    //     let heroSideTab = document.querySelector('.section-hero__tab')

    //     // hide hero side tab when when form is submitted
    //     if (!sessionStorage.getItem('kk_entry_filled')) {
    //         if (heroSideTab) {
    //             heroSideTab.style.display = 'flex'
    //             heroSideTab.addEventListener('click', function () {
    //                 MicroModal.show('entryPopup', microModalSettings)
    //             })
    //         }
    //     }

    //     // only auto show entry popup once
    //     var popup_viewed = sessionStorage['entryPopupViewed']
    //     if (popup_viewed != 'viewed' && window.location.pathname == '/') {
    //         setTimeout(function () {
    //             MicroModal.show('entryPopup', microModalSettings)
    //             sessionStorage['entryPopupViewed'] = 'viewed'
    //         }, 3000)
    //     }

    //     // hide hero side tab when when form is submitted
    //     let entryForm = document.querySelector('#entryPopup form')
    //     if (entryForm) {
    //         entryForm.addEventListener('submit', function () {
    //             sessionStorage.setItem('kk_entry_filled', 1)

    //             if (heroSideTab) {
    //                 heroSideTab.classList.add('fade-out')
    //             }
    //         })
    //     }
    // }

    /**
     *
     * Popups that show when your cursor leaves the page
     *
     */
    // function exitIntent() {
    //     if (!show_exit_intent) {
    //         return
    //     }

    //     var exitHappened = 0
    //     let eiModal = [].slice.call(document.querySelectorAll('#exitPopup'))
    //     var exit_viewed = sessionStorage['exitViewed']

    //     if (exit_viewed == 'viewed') {
    //         return
    //     }

    //     eiModal.map((modal) => {
    //         return setTimeout(function () {
    //             document.addEventListener('mouseout', function (evt) {
    //                 if (
    //                     ((evt.toElement === null &&
    //                         evt.relatedTarget === null) ||
    //                         (typeof evt.toElement == 'undefined' &&
    //                             evt.relatedTarget === null)) &&
    //                     exitHappened < 1
    //                 ) {
    //                     if (!document.querySelector('.modal.is-open')) {
    //                         MicroModal.show(modal.id, microModalSettings)
    //                         sessionStorage['exitViewed'] = 'viewed'
    //                         exitHappened = 1
    //                     }
    //                 }
    //             })
    //         }, 4000)
    //     })
    // }

    /**
     *
     * Helper for klaviyo forms, triggers tracking and lead library stuff
     * In the likely situation this site uses klaviyo, youll need this instead of the above exitintent/entry modal scripts
     *
     */
    function klaviyoPopups() {
        let klaviyoTriggers = document.querySelectorAll('[data-klaviyo]')

        if (klaviyoTriggers.length) {
            // triggers a form popup to show
            klaviyoTriggers.forEach(function (el, index) {
                el.addEventListener('click', function () {
                    console.log('clicked and called: ', el.dataset.klaviyo)
                    window._klOnsite = window._klOnsite || []
                    window._klOnsite.push(['openForm', el.dataset.klaviyo])
                })
            })
        }

        // only show the side tab if they havent already filled out the form
        if (!sessionStorage.getItem('kk_entry_filled')) {
            _showSideTab()
        }

        let newsletterFormEl = false
        window.addEventListener('klaviyoForms', function (e) {
            // add an event listener to keep track of the form state, so we can send it to the lead library
            if (e.detail.type == 'open') {
                setTimeout(function () {
                    newsletterFormEl = document.querySelector(
                        '[data-testid="klaviyo-form-' + e.detail.formId + '"]'
                    )
                    newsletterFormEl.id = 'newsletter_form'

                    if (newsletterFormEl) {
                        let newsletterFormInput =
                            newsletterFormEl.querySelector('input')

                        if (newsletterFormInput) {
                            newsletterFormInput.addEventListener(
                                'keyup',
                                function () {
                                    newsletterFormEl =
                                        newsletterFormInput.closest('form')
                                }
                            )
                        }
                    }
                }, 1000)
            }

            // send to the lead library and fire tracking
            // requires kk-global class added to any form on the page to expose the _sendToLeadLibrary function
            if (e.detail.type == 'submit') {
                _hideSideTab()

                if (typeof dataLayer !== 'undefined') {
                    if (e.detail.formId) {
                        if (
                            newsletterFormEl &&
                            typeof _sendToLeadLibrary == 'function'
                        ) {
                            _sendToLeadLibrary(newsletterFormEl)
                        }
                    }
                }
            }
        })

        function _hideSideTab() {
            let heroSideTab = document.querySelector('.section-hero__tab')

            if (heroSideTab) {
                heroSideTab.classList.add('fade-out')
            }

            sessionStorage.setItem('kk_entry_filled', 1)
        }

        function _showSideTab() {
            let sideForm = document.querySelector('.section-hero__tab')

            if (sideForm) {
                sideForm.style.display = 'flex'
            }
        }
    }

    window.addEventListener('load', function () {
        modals()

        // entryPopup()
        // exitIntent()

        // use this if the exit/entry is built in klaviyo
        klaviyoPopups()
    })
})()
